import React, { useState } from "react";
import { Sparkles, X } from "lucide-react";

/**
 * "Free while in beta" notice — a plain rounded-card banner (icon + message, no pill)
 * that sits naturally inside any page's existing padded layout instead of needing a
 * page-specific full-bleed treatment. Used across AI Crawl Attribution, Ad Recs,
 * ChatGPT Ads, Revenue Attribution, and Page Audit — the single beta-notice component
 * for AI Visibility (replaced the earlier ChatGptAdsBetaBanner /
 * RevenueAttributionBetaBanner, which were per-page duplicates of the same idea).
 * Dismiss is in-memory only — a refresh (or remount on tab switch) shows it again.
 */
export const BetaFreeAccessBanner: React.FC<{ className?: string }> = ({ className = "" }) => {
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) return null;

    return (
        <div
            role="status"
            className={`flex items-center gap-3 rounded-xl border border-[#E4DEFB] bg-[#F4F1FF] px-4 py-3 ${className}`}>
            <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg bg-purple-100 text-purple-600">
                <Sparkles className="h-4 w-4" aria-hidden />
            </span>
            <p className="min-w-0 flex-1 text-[13px] leading-snug text-gray-700">
                <span className="font-semibold text-gray-900">Free while we&apos;re in beta.</span>{" "}
                Full access, no charge. We&apos;ll notify you before anything changes.
            </p>
            <button
                type="button"
                onClick={() => setDismissed(true)}
                aria-label="Dismiss beta notice"
                className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-md text-gray-400 transition-colors hover:bg-black/5 hover:text-gray-600">
                <X className="h-3.5 w-3.5" />
            </button>
        </div>
    );
};

export default BetaFreeAccessBanner;
